// Module
var code = `<section class="page-body default-content">

  <h2>Radio Buttons</h2>
  <p>
    Radio buttons allow users to select a single option from a group.
    SpyneJS styles radios with clear, centered indicators, token-driven colors,
    and accessible hint text for validation states.
  </p>

  <!-- Default -->
  <h3>Default Radio</h3>
  <div class="form-examples">
    <label class="radio" for="radio-default">
      <input id="radio-default" type="radio" name="example" />
      Default Radio
    </label>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;label class="radio" for="radio-default"&gt;
  &lt;input id="radio-default" type="radio" name="example" /&gt;
  Default Radio
&lt;/label&gt;
    </code></pre>
  </div>

  <!-- Selected -->
  <h3>Selected State</h3>
  <div class="form-examples">
    <label class="radio" for="radio-selected">
      <input id="radio-selected" type="radio" name="example" checked />
      Selected Option
    </label>
  </div>

  <!-- Disabled -->
  <h3>Disabled Radio</h3>
  <div class="form-examples">
    <label class="radio" for="radio-disabled">
      <input id="radio-disabled" type="radio" name="example" disabled />
      Disabled Option
    </label>
  </div>

  <!-- Validation -->
  <h3>Validation States</h3>
  <p>
    Apply <code>.success</code> or <code>.error</code> classes directly to radios for validation feedback.
    Include hint text for better accessibility.
  </p>
  <div class="form-examples">
    <div>
      <label class="radio" for="radio-success">
        <input id="radio-success" type="radio" name="example2" class="success" checked />
        Success Radio
      </label>
      <div class="input-hint success">✓ Option selected successfully</div>
    </div>
    <div>
      <label class="radio" for="radio-error">
        <input id="radio-error" type="radio" name="example2" class="error" checked />
        Error Radio
      </label>
      <div class="input-error-label">✕ Invalid choice</div>
    </div>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;label class="radio" for="radio-success"&gt;
  &lt;input id="radio-success" type="radio" name="example2" class="success" checked /&gt;
  Success Radio
&lt;/label&gt;
&lt;div class="input-hint success"&gt;✓ Option selected successfully&lt;/div&gt;

&lt;label class="radio" for="radio-error"&gt;
  &lt;input id="radio-error" type="radio" name="example2" class="error" checked /&gt;
  Error Radio
&lt;/label&gt;
&lt;div class="input-error-label"&gt;✕ Invalid choice&lt;/div&gt;
    </code></pre>
  </div>

  <!-- Accessibility -->
  <h3>Accessibility</h3>
  <ul>
    <li>Always group radios with the same <code>name</code> so only one can be selected.</li>
    <li>Use hint text and icons (✓, ✕) so validation is not communicated by color alone.</li>
    <li>Wrap radios in labels for a larger click target and improved usability.</li>
  </ul>

  <!-- Back link -->
  <p>
    <a class="route-link" data-channel="ROUTE"
       data-page-id="elements" data-topic-id="forms" data-option-id=""
       href="/elements/forms">← Back to Forms Overview</a>
  </p>

</section>
`;
// Exports
module.exports = code;